<template>
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-12 w-12 sm:h-9 sm:w-9"
  >
    <path
      d="M38.537 13.5131L24.2444 1.54139C21.7907 -0.513797 18.2117 -0.513797 15.758 1.54139L1.46541 13.5131C-0.269393 14.9665 -0.49601 17.5531 0.957469 19.2801C1.67639 20.1397 2.71571 20.6632 3.82536 20.7336V32.377C3.82536 34.6276 5.65393 36.4562 7.91229 36.464H16.6957V26.3834C16.6957 24.5626 18.1726 23.0857 19.9934 23.0857C21.8141 23.0857 23.291 24.5626 23.291 26.3834V36.4718H32.0822C34.3328 36.4718 36.1614 34.6432 36.1692 32.3849V20.7414C38.4275 20.5929 40.1389 18.6393 39.9904 16.381C39.9123 15.2713 39.3887 14.232 38.537 13.5131ZM35.9035 19.1863H34.6063V32.3849C34.6063 33.7758 33.481 34.9089 32.0822 34.9089H24.8539V26.3834C24.8539 23.6952 22.6737 21.5228 19.9934 21.5228C17.3052 21.5228 15.1328 23.7031 15.1328 26.3834V34.9089H7.91229C6.52133 34.9089 5.38824 33.7836 5.38824 32.3927V19.1863H4.09886C1.7311 19.1863 0.660522 16.2325 2.47346 14.7087L16.766 2.737C18.6415 1.1663 21.3687 1.1663 23.2442 2.737L37.5289 14.7165C39.3418 16.2325 38.2713 19.1863 35.9035 19.1863Z"
      fill="currentColor"
    />
  </svg>
</template>
